import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HomeHero from './components/HomeHero';
import HomeCategories from './components/HomeCategories';
import HomeFeaturedArticles from './components/HomeFeaturedArticles';
import HomeStats from './components/HomeStats';
import HomeFAQ from './components/HomeFAQ';
import { siteConfig } from '@/mocks/data';

export default function Home() {
  return (
    <>
      <SchemaOrg type="Organization" />
      <SchemaOrg type="WebSite" />
      <SchemaOrg
        type="WebPage"
        data={{
          name: siteConfig.name,
          description: siteConfig.description,
          url: siteConfig.url,
          inLanguage: 'zh-CN',
        }}
      />
      <SEOHead
        title={`${siteConfig.name} - ${siteConfig.tagline}`}
        description={siteConfig.description}
        keywords={siteConfig.keywords}
        canonicalUrl={siteConfig.url}
        ogImage="https://readdy.ai/api/search-image?query=Clean%20modern%20website%20navigation%20concept%20with%20shield%20icon%2C%20warm%20coral%20and%20cream%20gradient%2C%20professional%20design%2C%20safe%20browsing%20theme%2C%20minimalist%20composition&width=1200&height=630&seq=home-og-image&orientation=landscape"
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <article>
            <HomeHero />
            <HomeCategories />
            <HomeFeaturedArticles />
            <HomeStats />
            <HomeFAQ />
          </article>
        </main>
        <Footer />
        <ScrollToTop />
      </div>
    </>
  );
}